import { registerMicroApps, start,setDefaultMountApp,runAfterFirstMounted } from 'qiankun';
import render from './render.jsx';
const isDev =window.location.host ==='dev.vets.cn'
render({ loading: true });

const loader = loading => render({ loading });

registerMicroApps([
  {
    name: 'react', // app name registered
    entry: `//${window.reactDomain}`,
    container: '#vets-main-content',
    activeRule: ['/utest/react/teacher','/utest/react/student','/itest/reacta/admin'],
    loader
  }
],
{
  beforeLoad: [
    app => {
      // console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
    },
  ],
  beforeMount: [
    app => {
      // console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
    },
  ],
  afterUnmount: [
    app => {
      // console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
    },
  ],
});

start();
runAfterFirstMounted(() => {
  // console.log('[MainApp] first app mounted');
});
setDefaultMountApp("react")